import { ColumnDef } from "@tanstack/react-table";
import { Fragment, ReactNode } from "react";
import { User } from "@/types/v2";
import { HeaderSortable } from "@/components/Base/HeaderSortable";
import { firestoreToDateTime } from "@/lib/utils";
import { Header } from "@/components/Base/Header";
import { Badge } from "@/components/Base/Badge";
export type DatatableUser = User;

interface ColumnProps {
  actions: (user: DatatableUser) => ReactNode[];
}

const createActionsColumn = ({
  actions,
}: ColumnProps): ColumnDef<DatatableUser> => ({
  accessorKey: "actions",
  header: "",
  cell: ({ row }) => {
    const item = row.original;
    return (
      <div className="flex gap-2">
        {actions(item).map((action, index) => (
          <Fragment key={`action-${item.id}-${index}`}>{action}</Fragment>
        ))}
      </div>
    );
  },
});

const userColumns = (props?: ColumnProps) => {
  const col: ColumnDef<DatatableUser>[] = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "firstName",
      header: () => <Header title={"First Name"} />,
    },
    {
      accessorKey: "lastName",
      header: () => <Header title={"Last Name"} />,
    },
    {
      accessorKey: "email",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Email"} />
      ),
    },
    {
      accessorKey: "emailVerified",
      header: () => <Header title={"Email Verified"} />,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <Badge
            variant={"default"}
            className={
              item.emailVerified
                ? "bg-success hover:bg-success/80"
                : "bg-destructive hover:bg-destructive/80"
            }
          >
            {item.emailVerified ? "Verified" : "Not Verified"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "displayName",
      header: () => <Header title={"Display Name"} />,
    },
    {
      accessorKey: "createdAt",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Created At"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="text-sm">
            {firestoreToDateTime(item.createdAt)?.toLocaleString()}
          </div>
        );
      },
    },
    {
      accessorKey: "lastLoginTime",
      header: ({ column }) => (
        <HeaderSortable column={column} title={"Last Login"} />
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="text-sm">
            {firestoreToDateTime(item.lastLoginTime)?.toLocaleString()}
          </div>
        );
      },
    },
  ];

  if (props) {
    col.push(createActionsColumn(props));
  }
  return col;
};

export { userColumns };
